
namespace Matrix.Workflow {

    @Serenity.Decorators.registerClass()
    export class TaskStatusGrid extends SiteEntityGrid<TaskStatusRow, any> {
        protected getColumnsKey() { return 'Workflow.TaskStatus'; }
        protected getDialogType() { return TaskStatusDialog; }
        protected getIdProperty() { return TaskStatusRow.idProperty; }
        protected getLocalTextPrefix() { return TaskStatusRow.localTextPrefix; }
        protected getService() { return TaskStatusService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}